<template>
  <div
    class="text-field-container"
    :class="{ 'text-field-container-label-top': labelAlign == 'top' }"
  >
    <div class="text-field-container-label-container" v-if="showLabel">
      <label-field :label="labelText" :requird="requird"></label-field>
    </div>
    <slot>
      <div
        class="text-field-container-input-container"
        :class="{
          'text-field-container-input-container-top': labelAlign == 'top',
        }"
      >
        <slot name="rightInput">
          <el-input
            border="0"
            :type="type"
            v-if="inputType"
            class="input-container-input"
            v-model="stringValue"
            :placeholder="readOnly ? '' : placeholder"
            :size="size"
            :disabled="readOnly"
            :clearable="clearable"
            :rows="rows"
            @input="input"
          />
          <el-input-number
            v-if="type == 'number'"
            class="input-container-input"
            v-model.number="numberValue"
            :placeholder="placeholder"
            border="0"
            :precision="precision"
            :size="size"
            :min="0"
            :controls="false"
            :disabled="readOnly"
            :clearable="clearable"
            @input="numberInput"
          >
          </el-input-number>
          <el-date-picker
            v-if="datePickerType"
            :type="type"
            class="input-container-input"
            v-model="dateValue"
            :placeholder="placeholder"
            :size="size"
            :disabled="readOnly"
            :clearable="clearable"
            @change="dateInput"
          >
          </el-date-picker>
          <el-date-picker
            v-if="datePickerRangeType"
            :type="type"
            :range-separator="rangeSeparator"
            class="input-container-input"
            v-model="stringValue"
            :start-placeholder="startPlaceholder"
            :end-placeholder="endlaceholder"
            :size="size"
            :format="dateFormat"
            :disabled="readOnly"
            :value-format="dateFormat"
            :clearable="clearable"
            @change="input"
          >
          </el-date-picker>
          <el-radio-group
            class="checkbox-group"
            :disabled="readOnly"
            v-if="type == 'radio'"
            v-model="stringValue"
            @change="input"
          >
            <el-radio
              class="checkbox-group-item"
              v-for="(item, index) in fieldData"
              :label="item.value"
              :key="`checkbox-group-item${index}`"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
          <el-select
            ref="select"
            v-if="type == 'select'"
            filterable
            class="input-container-input"
            v-model="stringValue"
            :placeholder="placeholder"
            border="0"
            :size="size"
            :disabled="readOnly"
            :clearable="clearable"
            @visible-change="visibleChange"
            @change="input"
            allow-create
          >
            <el-option
              v-for="(item, index) in itemData"
              :key="`option${index}`"
              :label="item.label"
              :value="item.value"
              style="
                padding-left: 20px;
                padding-right: 40px;
                box-sizing: border-box;
              "
            >
            </el-option>
            <el-pagination
              small
              layout="prev, pager, next"
              :page-size="pageSize"
              :current-page="currentPageIndex"
              :total="totalSize"
              v-if="showSelectPagenation"
              :hide-on-single-page="true"
              @current-change="pageChange"
            >
            </el-pagination>
          </el-select>

          <!-- selectChildData -->
          <el-select
            ref="selectChild"
            v-if="type == 'selectChild'"
            filterable
            class="input-container-input"
            v-model="stringValue"
            :placeholder="placeholder"
            border="0"
            :size="size"
            :disabled="readOnly"
            :clearable="clearable"
            @visible-change="visibleChange"
            @change="input"
          >
            <el-option
              v-for="(item, index) in selectChildData"
              :key="`option${index}`"
              :label="item.Name"
              :value="item.id"
              style="
                padding-left: 20px;
                padding-right: 40px;
                box-sizing: border-box;
              "
            >
            </el-option>
            <el-pagination
              small
              layout="prev, pager, next"
              :page-size="pageSize"
              :current-page="currentPageIndex"
              :total="totalSize"
              v-if="showSelectPagenation"
              :hide-on-single-page="true"
              @current-change="pageChange"
            >
            </el-pagination>
          </el-select>

          <div class="input-container-upload" v-if="type == 'upload'">
            <div class="input-container-upload-text">
              {{ uploadFileName(uploadFile) }}
            </div>
            <el-upload
              action="123"
              :show-file-list="false"
              :disabled="readOnly"
              :auto-upload="false"
              :on-change="uploadFileFn"
            >
              <template #trigger>
                <el-button round size="medium" type="primary"
                  >选取文件</el-button
                >
              </template>
            </el-upload>
          </div>
          <el-checkbox-group
            class="checkbox-group"
            v-model="checkboxItems"
            v-if="type == 'checkbox'"
            :disabled="readOnly"
            @change="inputCheckbox"
          >
            <el-checkbox
              class="checkbox-group-item"
              v-for="(item, index) in itemData"
              :label="item.value"
              :key="`checkbox-${index}`"
            >
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>

          <el-cascader
            ref="select"
            v-if="type == 'selectLv'"
            class="input-container-input"
            v-model="stringValue"
            :props="{ checkStrictly: true }"
            :options="itemData"
            :placeholder="placeholder"
            border="0"
            :size="size"
            :disabled="readOnly"
            :clearable="clearable"
            @visible-change="visibleChange"
            @change="input"
          >
          </el-cascader>
        </slot>
      </div>
    </slot>
  </div>
</template>

<script>
import labelField from "@/components/labelField.vue";
import {
  defineComponent,
  reactive,
  toRefs,
  watch,
  computed,
  onMounted,
  onBeforeMount,
} from "vue";

export default defineComponent({
  name: "textField",
  components: {
    labelField,
  },
  props: {
    labelText: {
      type: String,
      default: "label",
    },
    placeholder: {
      type: String,
      default: "请输入",
    },
    startPlaceholder: {
      type: String,
      default: "开始时间",
    },
    endlaceholder: {
      type: String,
      default: "结束时间",
    },
    rangeSeparator: {
      type: String,
      default: "至",
    },
    value: null,
    selectValueFn: {
      type: Function,
      default: null,
    },
    type: {
      type: String,
      default: "text",
    },
    precision: {
      type: Number,
      default: 0,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    labelAlign: {
      type: String,
      default: "left",
    },
    requird: {
      type: Boolean,
      default: false,
    },
    fieldData: {
      type: Array,
      default() {
        return [];
      },
    },
    selectChildData: {
      type: Array,
      default() {
        return [];
      },
    },
    selectRemoteSearchData: {
      type: Function,
      default: null,
    },
    showSelectPagenation: {
      type: Boolean,
      default: false,
    },
    tabelRow: {
      type: Object,
      default() {
        return {};
      },
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: null,
    },
    refKey: {
      type: String,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 2,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    let data = reactive({
      size: "small",
      itemData: [],
      uploadFile: "",
      checkboxItems: [],
      numberValue: "",
      dateValue: null,
      stringValue: "",
      currentPageIndex: 1,
      totalSize: 0,
      pageSize: 0,
      dateFormat: "yyyy-MM-dd",
    });

    let methods = {
      async setComboData() {
        let obj = null;
        if (props.refKey) {
          obj = {};
          obj[props.refKey] = props.formData[props.refKey];
        }
        await methods.remoteData(obj);
      },
      input() {
        console.log(data.stringValue);
        emit("update:value", data.stringValue + "");
        emit("change", data.stringValue + "");
      },
      inputCheckbox(v) {
        // debugger
        emit("update:value", data.checkboxItems);
      },
      numberInput() {
        emit("update:value", data.numberValue);
      },
      dateInput() {
        if (data.dateValue) {
          let year = data.dateValue.getFullYear().toString().PadLeft(4, "0");
          let month = (data.dateValue.getMonth() + 1)
            .toString()
            .PadLeft(2, "0");
          let date = data.dateValue.getDate().toString().PadLeft(2, "0");
          let hour = data.dateValue.getHours().toString().PadLeft(2, "0");
          let minute = data.dateValue.getMinutes().toString().PadLeft(2, "0");
          let sec = data.dateValue.getSeconds().toString().PadLeft(2, "0");

          emit(
            "update:value",
            `${year}-${month}-${date} ${hour}:${minute}:${sec}`
          );
          // emit("update:value", `${year}-${month}-${date}`)
        } else {
          emit("update:value", "");
        }
      },
      checkboxChange(val) {
        // console.log(val)
        // debugger
        emit("update:value", (data.checkboxItems = val));
      },
      visibleChange(tag) {
        if (tag && props.refKey) {
          methods.setComboData();
        }
      },
      async remoteData(parms) {
        if (props.selectRemoteSearchData) {
          let dataSource = await props.selectRemoteSearchData(
            data.pageSize,
            data.currentPageIndex,
            parms
          );
          data.totalSize = dataSource.total;
          data.itemData = dataSource.data;
        }
      },
      uploadFileFn(file) {
        data.uploadFile = file.raw.name;
        emit("update:value", file.raw);
      },
      updateValue(value) {
        data.stringValue = value;

        if (props.type == "checkbox") {
          if (value === true) {
            console.log(typeof value);
            data.checkboxItems = [value];
            emit("update:value", [value]);
            return;
          }
          if (!value) {
            data.checkboxItems = [];
            emit("update:value", []);
          } else {
            if (typeof value === "string") {
              let z = new RegExp("'", "g");
              console.log("@3", (value = value.replace(z, "")));
              value = value.replace(z, "").split(",");
              let zz = value.map((i) => {
                return parseInt(i);
              });

              console.log("@4", zz);
              data.checkboxItems = zz;
              // debugger
            } else {
              data.checkboxItems = value;
            }
          }
        }

        if (props.type == "number") {
          if (!value) {
            data.numberValue = undefined;
            emit("update:value", undefined);
          } else if (isNaN(value)) {
            data.numberValue = undefined;
            emit("update:value", undefined);
          } else {
            data.numberValue = Number(value);
          }
        }

        if (computeds.datePickerType) {
          if (!value) {
            data.dateValue = "";
            emit("update:value", null);
            // console.log("更新执行")
          } else {
            data.dateValue = new Date(value);
          }
        }

        if (props.type == "select") {
          console.log(props.tabelRow, "tabelRow");
          // debugger
          if (props.selectValueFn) {
            let selectedValue = props.selectValueFn(
              props.value,
              props.tabelRow
            );

            data.stringValue = selectedValue;
            emit("update:value", selectedValue);
          }
        }
        if (props.type == "selectChild") {
          if (props.selectValueFn) {
            let selectedValue = props.selectValueFn(
              props.value,
              props.tabelRow
            );

            data.stringValue = selectedValue;
            emit("update:value", selectedValue);
          }
        }
      },
      pageChange() {
        methods.remoteData();
      },
      uploadFileName(v) {
        if (!v) {
          return "请选择文件";
        }

        return v;
      },
      async dataFilter(val) {
        console.log("@1", val);
        // console.log("@2",  data.itemData)
        let sourceData = await props
          .selectRemoteSearchData(data.pageSize, data.currentPageIndex, val)
          .then((res) => {
            return res.data;
          });

        if (val) {
          data.itemData = sourceData.filter((item) => {
            if (
              item.label.includes(val) ||
              item.label.toUpperCase().includes(val.toUpperCase())
            ) {
              return true;
            }
          });
        } else {
          data.itemData = sourceData;
        }
        // console.log('zx4',data.itemData) allow-create
        //  :filter-method="dataFilter" @focus="selectFocus" @blur="selectFocus"
        // console.log("data.itemData:", data.itemData)
        // if (val) {
        // 	this.options = this.optionsFilter.filter((item) => {
        // 		if (item.label.includes(val) || item.label.toUpperCase().includes(val.toUpperCase())) {
        // 		return true
        // 		}
        // 	})
        // } else {
        // 	this.options = this.optionsFilter;
        // }
      },
      async selectFocus(e) {
        let value = e.target.value;
        console.log("target-", value);
        if (value) {
          data.stringValue = value;
        }
      },
    };

    let computeds = {
      datePickerType: computed(() => {
        if (
          props.type === "date" ||
          props.type === "datetime" ||
          props.type === "year" ||
          props.type === "month" ||
          props.type === "dates" ||
          props.type === "week"
        ) {
          return true;
        } else {
          return false;
        }
      }),
      datePickerRangeType: computed(() => {
        if (
          props.type === "datetimerange" ||
          props.type === "daterange" ||
          props.type === "monthrange"
        ) {
          return true;
        } else {
          return false;
        }
      }),
      inputType: computed(() => {
        if (
          props.type === "text" ||
          props.type === "password" ||
          props.type === "textarea"
        ) {
          return true;
        } else {
          return false;
        }
      }),
    };

    watch(
      () => {
        return props.value;
      },
      (newValue) => {
        if (!props.selectRemoteSearchData) {
          // console.log('props.value---',newValue)
          methods.updateValue(newValue);
          // console.log('监视执行')
        }
      }
    );

    watch(
      () => {
        return data.stringValue;
      },
      (newValue) => {
        // debugger
        emit("update:value", newValue);
      }
    );
    watch(
      () => {
        return props.selectChildData;
      },
      (newV, oldV) => {
        console.log("watch--", newV);
        // debugger
        if (!props.selectRemoteSearchData) {
          data.itemData = newV;
        }
      }
    );
    onBeforeMount(async () => {
      if (props.fieldData) {
        data.itemData = props.fieldData;
      }

      await methods.setComboData();
    });
    onMounted(() => {
      // 还要考虑排除其他情况的可能
      if (!props.selectRemoteSearchData && !props.fieldData.length) {
        data.itemData = props.selectChildData;
      }
      methods.updateValue(props.value);
    });

    return {
      ...toRefs(data),
      ...methods,
      ...computeds,
    };
  },
});
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

.text-field-container {
  display: flex;
  width: auto;
  height: auto;
  align-items: center;
  align-content: center;
  @include background_color("text-field-bg-color");
  box-sizing: border-box;
  overflow: hidden;

  &.text-field-container-label-top {
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
    height: auto;
  }

  .text-field-container-label-container {
    display: flex;
    align-items: center;
    align-content: center;
    max-width: 160px;
    width: fit-content;
    height: 18px;
    font-size: 18px;
    line-height: 18px;
    padding-right: 5px;
    box-sizing: border-box;
    white-space: nowrap;
  }

  .text-field-container-input-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    align-content: center;
    //@include border_all("text-field-border");
    border-radius: 4px;
    box-sizing: border-box;
    // padding-left: 16px;
    // padding-right: 16px;

    &.text-field-container-input-container-top {
      //margin-top: 20px;
    }

    &:deep(.input-container-input) {
      display: flex;
      align-items: center;
      align-content: center;
      height: 100%;
      width: 100%;
      line-height: 16px;
      @include font_color("text-field-font-color");
      font-size: 16px;
      border: 0px;
      outline: 0px;
      justify-content: flex-start;
      position: relative;

      .el-input__inner {
        text-align: left;
      }

      &:deep(.option-item) {
        width: 200px;
      }
    }

    .input-container-upload {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      align-content: center;
      box-sizing: border-box;

      .input-container-upload-text {
        display: flex;
        align-items: stretch;
        align-content: stretch;
        line-height: 16px;
        font-size: 16px;
        @include font_color("text-field-font-color");
        width: 200px;
        height: 100%;
        overflow: hidden;
        @include border_all("text-field-border");
        margin-right: 5px;
        border-radius: 5px;
        padding-top: 5px;
        padding-bottom: 5px;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }

    .checkbox-group {
      display: flex;
      align-items: center;
      align-content: center;
      flex-wrap: wrap;

      .checkbox-group-item {
        margin-left: 10px;

        &:first-child {
          margin-left: 0px;
        }
      }
    }

    .row {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      align-content: center;
      @include font_family("font_family");
      font-size: 16px;
      @include font_color("radio-field-text-color");

      .radio-item {
        display: flex;
        align-items: center;
        align-content: center;

        &:nth-child(n + 2) {
          margin-left: 20px;
        }

        .radio {
          margin-left: 40px;
          margin-right: 5px;

          &:first-child {
            margin-left: 0px;
          }
        }
      }
    }

    .select {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      align-content: center;
      @include font_family("font_family");
      font-size: 16px;
      @include font_color("radio-field-text-color");
      flex-direction: column;

      .options-container {
        position: relative;
        width: 100%;
        height: 0px;

        .options {
          position: absolute;
          left: 0px;
          top: 0px;
          height: 0px;
          width: 100%;
          border: rgb(232, 232, 232) 1px solid;
          border-radius: 6px;
          margin-top: 5px;
          background-color: white;
          padding: 10px;
          box-sizing: border-box;
          z-index: -1;
          cursor: pointer;
          opacity: 0px;
          transition: 0.3s;

          &.options-show {
            height: auto;
            opacity: 1;
            z-index: 3;
            transition: all 0.3s;
          }

          .option {
            width: 100%;
            height: 40px;
            display: flex;
            align-items: center;
            align-content: center;
            line-height: 16px;
            font-size: 16px;
            @include font_family("font_family");

            &:hover {
              @include background_color("select-picker-hover-bg-color");
            }
          }
        }
      }
    }
  }
}

input {
  &:focus {
    outline: none;
  }

  &::-webkit-outer-spin-button {
    webkit-appearance: none;
  }

  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  &::-webkit-input-placeholder {
    color: rgb(150, 150, 150);
    line-height: 16px;
    font-size: 16px;
    font-family: hanSan;
    height: 100%;
    width: 100%;
  }

  &::-moz-placeholder {
    color: rgb(150, 150, 150);
    line-height: 16px;
    font-size: 16px;
    font-family: hanSan;
    height: 100%;
    width: 100%;
  }

  /* firefox 19+ */
  &::-ms-input-placeholder {
    color: rgb(150, 150, 150);
    line-height: 16px;
    font-size: 16px;
    font-family: hanSan;
    height: 100%;
    width: 100%;
  }

  /* Internet Explorer 10+ */
  &::-moz-placeholder {
    color: rgb(150, 150, 150);
    line-height: 16px;
    font-size: 16px;
    font-family: hanSan;
    height: 100%;
    width: 100%;
  }
}
</style>
